import { gql } from "@apollo/client";

export const GET_DEFAULT_ACCOUNT = gql`
  query GetDefaultAccount {
    instagrams {
      id
      username
    }
  }
`;

export interface InstagramAccountSummary {
  id: string;
  username: string;
}

export interface GetDefaultAccountData {
  instagrams: InstagramAccountSummary[];
}
